export interface MediaOrder {
    mediaId: number;
    order: number;
    imageUrl: string;
}
